import Vue from 'vue';
import { NavBar,Switch ,Tag,Grid,GridItem,Collapse,Toast,
    CollapseItem,Image,Col,Row,Search,Icon,
    Picker,Popup,Cell,Form,Field,Button,DropdownMenu,
    DropdownItem,CellGroup,Uploader,Calendar,Tab,
    Tabs,Radio,RadioGroup,Checkbox,CheckboxGroup,
    DatetimePicker,List,Tabbar, TabbarItem, Dialog, PullRefresh, NoticeBar, CountDown, Card, SwipeCell, Divider, Lazyload,
    Overlay
} from 'vant';


Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Search);
Vue.use(Icon)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(Image)
Vue.use(NoticeBar)
Vue.use(CountDown)
Vue.use(Uploader)
Vue.use(Card)
Vue.use(Tag)
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(SwipeCell);
Vue.use(Divider)
Vue.use(Lazyload)
Vue.use(Overlay)
Vue.use(Switch)
// Vue.use(Toast)


// WEBPACK FOOTER //
// ./src/vant/index.js